module.exports = __webpack_public_path__ + "static/stripe_create_webhook-9b8ac0b3556812cf44a573a9392baea0.png";